import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {AsAgentMapComponent} from "../component/protected-components/as-agent-map/as-agent-map.component";
import {
    AsAppointmentEventComponent
} from "../component/protected-components/as-appointment-event/as-appointment-event.component";
import {
    AsAppointmentRescheduleAppointmentComponent
} from "../component/protected-components/as-appointment-event/as-appointment-reschedule-appointment/as-appointment-reschedule-appointment.component";
import {
    AsAppointmentCancelAppointmentComponent
} from "../component/protected-components/as-appointment-event/as-appointment-cancel-appointment/as-appointment-cancel-appointment.component";
import {
    AsAppointmentInlineComponent
} from "../component/protected-components/as-appointment-inline-component/as-appointment-inline-component";
import {
    AsCustomerAppointmentDetailPage
} from "../component/protected-components/as-customer-appointment-detail-page/as-customer-appointment-detail.page";
import {
    AsCustomerAppointmentPage
} from "../component/protected-components/as-customer-appointment-page/as-customer-appointment.page";
import {AsFreeSlotComponent} from "../component/protected-components/as-free-slot/as-free-slot.component";
import {AsMsEventComponent} from "../component/protected-components/as-ms-event/as-ms-event.component";
import {
    MsBusinessStaffMembersComponent
} from "../component/protected-components/ms/ms-business-staff-members/ms-business-staff-members.component";
import {Provider} from "@angular/core";

const asModuleEntry: TestModuleDefinition = {
    key: 'as',
    label: 'Appointment (as)',
    components: [
        {
            key: 'AsAgentMapComponent',
            component: AsAgentMapComponent,
            selector: 'as-agent-map',
            label: 'Agent Map',
            type: 'Component',
        },
        {
            key: 'AsAppointmentEventComponent',
            component: AsAppointmentEventComponent,
            selector: 'as-appointment-component',
            label: 'Appointment Event',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'AsAppointmentRescheduleAppointmentComponent',
            component: AsAppointmentRescheduleAppointmentComponent,
            selector: 'as-appointment-reschedule-appointment',
            label: 'Appointment Reschedule',
            type: 'Component',
        },
        {
            key: 'AsAppointmentCancelAppointmentComponent',
            component: AsAppointmentCancelAppointmentComponent,
            selector: 'as-appointment-cancel-appointment',
            label: 'Appointment Cancel',
            type: 'Component',
        },
        {
            key: 'AsAppointmentInlineComponent',
            component: AsAppointmentInlineComponent,
            selector: 'as-appointment-inline-component',
            label: 'Appointment Inline Component',
            type: 'Component',
        },
        {
            key: 'AsCustomerAppointmentDetailPage',
            component: AsCustomerAppointmentDetailPage,
            selector: 'as-customer-appointment-detail-page',
            label: 'Appointment Detail Page',
            type: 'Component',
        },
        {
            key: 'AsCustomerAppointmentPage',
            component: AsCustomerAppointmentPage,
            selector: 'as-customer-appointment-page',
            label: 'Appointment Page',
            type: 'PageComponent',
        },
        {
            key: 'AsFreeSlotComponent',
            component: AsFreeSlotComponent,
            selector: 'as-free-slot',
            label: 'Free Slot Component',
            type: 'Component',
        },
        {
            key: 'AsMsEventComponent',
            component: AsMsEventComponent,
            selector: 'as-ms-event-component',
            label: 'Ms Event Component',
            type: 'Component',
        },
        {
            key: 'MsBusinessStaffMembersComponent',
            component: MsBusinessStaffMembersComponent,
            selector: 'as-ms-business-staff-members',
            label: 'MsBusiness Staff Members',
            type: 'Component',
        },

        // {
        //     key: 'AppointmentBookingFullComponent',
        //     component: AppointmentBookingFullComponent,
        //     selector: 'as-appointment-booking-full',
        //     label: 'Appointment Booking Full',
        //     type: 'Component',
        // },
        // {
        //     key: 'AppointmentBookingSideComponent',
        //     component: AppointmentBookingSideComponent,
        //     selector: 'as-appointment-booking-side',
        //     label: 'Appointment Booking Side',
        //     type: 'Component',
        // },
        // {
        //     key: 'AppointmentBookingComponent',
        //     component: AppointmentBookingComponent,
        //     selector: 'as-appointment-booking',
        //     label: 'Appointment Booking',
        //     type: 'Component',
        // }
    ]
}

export const AS_TEST_PROVIDERS: Provider[] = [
    {
        provide: TEST_MODULE_REGISTRY, useValue: asModuleEntry, multi: true
    }
]